import React from 'react';
import { Card, Button, WhiteSpace, WingBlank, InputItem, List, Accordion, Modal } from 'antd-mobile';
import axios from 'axios';

import 'antd-mobile/dist/antd-mobile.css'; 
import './App.css';

const Alert = Modal.alert;

class App extends React.Component  {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      sfzh: ''
    };
  }

  checkStatus(e) {
    axios.post(`/enrollsys/admission/getScores`, "u="+this.state.value+"&p="+this.state.sfzh, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*"
      }
    })
    .then(response => {
      if (response.status == 200 && response.data.data != null && response.data.code == 0) {
        // console.log(response.data.data);
        sessionStorage.setItem("info", JSON.stringify(response.data.data));
        window.location.href = '#/info';
      }else{
        Alert('提示', '未找到匹配数据', [
          { text: '确定', onPress: () => console.log('ok') },
        ])
      }
    }, err => {
      console.log('b ' + err.status);
      Alert('提示', '网络或者系统异常，请稍后重试', [
        { text: '确定', onPress: () => console.log('ok') },
      ])
    })
    .catch((error) => {
      console.log('c ' + error);
      Alert('提示', '网络或者系统异常，请稍后重试', [
        { text: '确定', onPress: () => console.log('ok') },
      ])
    });
  }

  onChange = (key) => {
    console.log(key);
  }

  inputOnChange = (value) => {
    this.setState({
      value,
    });
  }
  input2OnChange = (sfzh) => {
    this.setState({
      sfzh,
    });
  }

  render() {
    return (
      <div>
      <WingBlank size="lg">
      <WhiteSpace size="lg" />

      <Card>
        <Card.Body>
          <WhiteSpace size="lg"/>
          <div style={{textAlign: 'center'}}><img src="hnjtlogo.png" width="150px"></img></div>
          <WhiteSpace size="lg"/>
          <div style={{textAlign: 'center', color: 'rgb(28, 72, 154)'}}>湖南交通工程学院2023年"专升本"考试成绩公示</div>
          <WhiteSpace size="lg"/>
        </Card.Body>
      </Card>
      <List renderHeader={() => <font style={{color: 'rgb(28, 72, 154)', fontSize: '15px'}}>成绩查询</font>}>
      <InputItem style={{color: 'rgb(28, 72, 154)', fontSize: '15px'}}
            onChange={this.inputOnChange}
            value={this.state.value}
            placeholder="请输入准考证号">
            <div style={{ backgroundImage: 'url(https://zos.alipayobjects.com/rmsportal/DfkJHaJGgMghpXdqNaKF.png)', backgroundSize: 'cover', height: '22px', width: '22px' }} />
          </InputItem>
        <InputItem style={{color: 'rgb(28, 72, 154)', fontSize: '15px'}}
            onChange={this.input2OnChange}
            value={this.state.sfzh}
            placeholder="请输入身份证号">
            <div style={{ backgroundImage: 'url(https://wx.hnjt.edu.cn/idcard.png)', backgroundSize: 'cover', height: '22px', width: '22px' }} />
          </InputItem>
      </List>
      <WhiteSpace size="lg"/>

      <Accordion defaultActiveKey="0"  onChange={this.onChange}>
        <Accordion.Panel header={<font style={{color: 'rgb(28, 72, 154)', fontSize: '15px'}}>查询须知</font>}>
        <WingBlank size="lg">
           {/* <p style={{color: 'rgb(28, 72, 154)', fontSize: '15px'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;同学你好，由于你在本次专升本考试中成绩靠前，请于6月5日前在湖南交通工程学院微信公众号预缴1万元学费，我校将择优录取，如放弃就读，我校将根据省教育厅的政策，按成绩往后顺延录取。请注意保存好缴费凭证（缴费完毕后截图）。考试成绩和录取结果将在学校官网公布。</p> */}
           <p style={{color: 'rgb(28, 72, 154)', fontSize: '15px'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;输入准考证号和身份证号，然后点击下方查询按钮。身份证号中的X请输入大写英文X。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;咨询电话：0734-8815013。</p>
        </WingBlank>
        </Accordion.Panel>
      </Accordion>

      </WingBlank>
      <div  style={{position: 'fixed', bottom: '5px', width: "100%", color: 'rgb(28, 72, 154)'}}>
      <WingBlank size="lg">
        <Button type="primary" onClick={this.checkStatus.bind(this)} style={{fontSize: '15px'}}>查询</Button>
      </WingBlank>
      </div> 
      
      </div>
    )
  }
}

export default App;
